
import { SchemaFormFieldCondition } from '../types';

export const evaluateFieldConditions = (
  conditions: SchemaFormFieldCondition[] = [],
  showWhen: 'all' | 'any' = 'all',
  formData: Record<string, any> = {}
): boolean => {
  if (!conditions || conditions.length === 0) {
    return true; // No conditions means field is always visible
  }

  const results = conditions.map(condition => {
    const targetValue = formData[condition.targetFieldId];
    
    switch (condition.operator) {
      case 'equals':
        return targetValue === condition.value;
      case 'not_equals':
        return targetValue !== condition.value;
      case 'contains':
        return typeof targetValue === 'string' && targetValue.includes(condition.value);
      case 'not_contains':
        return typeof targetValue === 'string' && !targetValue.includes(condition.value);
      case 'greater_than':
        return Number(targetValue) > Number(condition.value);
      case 'less_than':
        return Number(targetValue) < Number(condition.value);
      case 'is_empty':
        return !targetValue || targetValue === '' || (Array.isArray(targetValue) && targetValue.length === 0);
      case 'is_not_empty':
        return targetValue && targetValue !== '' && (!Array.isArray(targetValue) || targetValue.length > 0);
      default:
        return true;
    }
  });

  return showWhen === 'all' ? results.every(Boolean) : results.some(Boolean);
};
